/**
 * Representa dados de exibição em tela de um método.
 */
export class DisplayMethod {
  executionContext: string[];
  displayConfigs: MethodDisplayConfigs;
  icon: string;
  identifier: string;
  name: string;
  inputClassId: string;
  outputClassId: string;
  minimumObjects: number;
  maximumObjects: number;

  constructor(data?: any) {
    Object.assign(this, data);
  }

}

export type MethodDisplayConfigs = {
  [locationType in Location]?: ExhibitionMode[];
};

export type ExhibitionMode = 'MENU' | 'FEATURED';

export type Location = 'OBJECT_LIST' | 'OBJECT' | 'PIPELINE' | 'DRAFT';
